import React from 'react';
import { FaBook, FaEdit, FaTrash } from 'react-icons/fa';

export default function ClassTable({ classes, searchTerm, selectedGrade, onManageContent, onEdit, onDelete }) {
    const filteredClasses = classes.filter(cls => {
        const matchesSearch = cls.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
            cls.teacher_name.toLowerCase().includes(searchTerm.toLowerCase());
        const matchesGrade = selectedGrade === 'All' || cls.grade.toString() === selectedGrade;
        return matchesSearch && matchesGrade;
    });

    return (
        <div className="bg-white rounded-3xl shadow-xl shadow-gray-100 border border-gray-100 overflow-hidden">
            <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-100">
                    <thead>
                        <tr className="bg-gray-50/50">
                            <th className="px-8 py-5 text-left text-[10px] font-black text-gray-400 uppercase tracking-[0.2em]">Class Identity</th>
                            <th className="px-8 py-5 text-left text-[10px] font-black text-gray-400 uppercase tracking-[0.2em]">Assigned Teacher</th>
                            <th className="px-8 py-5 text-left text-[10px] font-black text-gray-400 uppercase tracking-[0.2em]">Schedule & Mode</th>
                            <th className="px-8 py-5 text-left text-[10px] font-black text-gray-400 uppercase tracking-[0.2em]">Premium Fee</th>
                            <th className="px-8 py-5 text-right text-[10px] font-black text-gray-400 uppercase tracking-[0.2em]">Operations</th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-50">
                        {filteredClasses.length > 0 ? (
                            filteredClasses.map((cls) => (
                                <tr key={cls.id} className="hover:bg-gray-50/50 transition-colors group">
                                    <td className="px-8 py-5">
                                        <div className="font-bold text-gray-900 group-hover:text-blue-600 transition-colors">{cls.name}</div>
                                        <div className="flex items-center gap-2 mt-1">
                                            <span className="px-2 py-0.5 bg-blue-50 text-blue-600 text-[10px] font-black rounded-md">GRADE {cls.grade}</span>
                                            <span className="text-[10px] text-gray-400 font-bold uppercase">{cls.subject}</span>
                                        </div>
                                    </td>
                                    <td className="px-8 py-5">
                                        <div className="flex items-center gap-3">
                                            <div className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center text-gray-400 text-xs font-bold">
                                                {cls.teacher_name ? cls.teacher_name.charAt(0) : '?'}
                                            </div>
                                            <div className="text-sm font-bold text-gray-700">{cls.teacher_name}</div>
                                        </div>
                                    </td>
                                    <td className="px-8 py-5">
                                        <div className="text-sm text-gray-600 font-medium">{cls.class_schedule}</div>
                                        <div className="flex items-center gap-2 mt-1">
                                            <span className={`w-1.5 h-1.5 rounded-full ${cls.type === 'Online' ? 'bg-purple-400' : 'bg-green-400'}`}></span>
                                            <span className="text-[10px] font-black text-gray-400 uppercase">{cls.type} • {cls.location}</span>
                                        </div>
                                    </td>
                                    <td className="px-8 py-5">
                                        <div className="text-sm font-black text-gray-900">LKR {parseFloat(cls.fee).toLocaleString()}</div>
                                    </td>
                                    <td className="px-8 py-5 text-right">
                                        <div className="flex justify-end gap-1">
                                            <button
                                                onClick={() => onManageContent(cls)}
                                                className="p-2.5 text-gray-400 hover:text-blue-600 hover:bg-blue-50 rounded-xl transition-all"
                                                title="Manage Content"
                                            >
                                                <FaBook size={16} />
                                            </button>
                                            <button
                                                onClick={() => onEdit(cls)}
                                                className="p-2.5 text-gray-400 hover:text-gray-900 hover:bg-gray-100 rounded-xl transition-all"
                                                title="Settings"
                                            >
                                                <FaEdit size={16} />
                                            </button>
                                            <button
                                                onClick={() => onDelete(cls.id)}
                                                className="p-2.5 text-gray-300 hover:text-red-600 hover:bg-red-50 rounded-xl transition-all"
                                                title="Remove"
                                            >
                                                <FaTrash size={16} />
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="5" className="px-8 py-20 text-center text-gray-400 font-bold">
                                    No classes matching your search.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
